// extracted by mini-css-extract-plugin
export default {"statusLabel":"MessagingStatusLabel_statusLabel__EfB10"};